import React, { Dispatch, SetStateAction, useEffect } from "react";

export function useOpenCloseMenu(
  props: Readonly<{
    isMouseOut: boolean;
    setIsCurrentMenuOpen?: Dispatch<SetStateAction<boolean>>;
  }>
) {
  useEffect(() => {
    const onTimeout = () => {
        if (props.setIsCurrentMenuOpen) {
            
        props.setIsCurrentMenuOpen(false);
      }
    };
    let timeoutId: NodeJS.Timeout;
    if (props.isMouseOut) {
      timeoutId = setTimeout(onTimeout, 300);
    }

    return () => {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }, [props.isMouseOut]);
}
